import { normalizeUrl } from './normalize-url';

export const openNewTab = (url: string) => {
  const normalizedUrl = normalizeUrl(url);
  window.open(normalizedUrl, '_blank');
};
